import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import './ConfirmationDialog.css';
import { Dialog } from '@mui/material';

function ConfirmationDialog(props) {
  return (
    <Dialog
      open={true}
      style={{
        backgroundColor: 'transparent',
      }}
    >
      <div className="backgroundconfirm">
        <span className="crossiconspan">
          <CloseIcon
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              props.closedialog(false);
            }}
          />
        </span>

        <div className="containerconfirm">
          <div className="crossbuttonconfirm">
            <h1> Warning!</h1>
            <p> Are you sure, you want to DELETE? </p>
            <div className="footer">
              <button
                id="canclbtn"
                onClick={() => {
                  props.closedialog(false);
                }}
              >
                Cancel
              </button>
              <button
                id="continuebtn"
                onClick={() => {
                  props.closedialog(true);
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default ConfirmationDialog;
